import { IGetCandidateResumeApiResponse } from '../types/CandidateResume.api';
import { ICandidateResumeEntity } from '../types/CandidateResume';

const toGetCandidateResumeResult = (
  response: IGetCandidateResumeApiResponse,
): ICandidateResumeEntity => {
  const apiData = response.data;

  return {
    id: apiData.id,
    professionalId: apiData.professionalId,
    professionalName: apiData.professionalName,
    professionalFirstName: apiData.professionalFirstName,
    professionalLastName: apiData.professionalLastName,
    professionalEmail: apiData.professionalEmail,
    professionalPhone: apiData.professionalPhone,
    summary: apiData.summary,
    experiences: apiData.experiences?.map((exp) => ({
      employerName: exp.employerName,
      title: exp.title,
      isCurrentEmployer: exp.isCurrentEmployer,
      startDate: exp.startDate,
      endDate: exp.endDate,
    })),
    education: apiData.education?.map((edu) => ({
      institutionName: edu.institutionName,
      graduationDate: edu.graduationDate,
    })),
  };
};

export const CandidateResumeAdapters = {
  toGetCandidateResumeResult,
};
